export enum PropertyOption {
    PROPERTY_TYPE,
    ENERGY_LABEL,
    PURCHASE_PRICE,
    SUSTAINABILITY,
    RENOVATION,
    SUMMARY
}

export enum PropertyTypeQuestion {
    PROPERTY_TYPE_BUTTON,
    SUMMARY
}

export enum EnergyLabelQuestion {
    ENERGY_LABEL_RADIO,
    SUMMARY
}

export enum PurchasePriceQuestion {
    PURCHASE_PRICE_AMOUNT,
    SUMMARY
}

export enum SustainabilityQuestion {
    SUSTAINABILITY_LOAN_BUTTON,
    SUSTAINABILITY_AMOUNT,
    SUMMARY
}

export enum RenovationQuestion {
    RENOVATION_BUTTON,
    RENOVATION_AMOUNT_INPUT,
    RENOVATION_TIP,
    SUMMARY
}
